interface Props {
  className?: string;
}

// Build stamp, normalised to exactly one "V" prefix; null when the env var is unset.
// Computed once at module load — CRA bakes the value in at build time. Exported so a
// layout can skip its version row entirely instead of rendering an empty one.
export const feVersionLabel = (() => {
  const raw = process.env.REACT_APP_FE_VERSION?.trim();
  return raw ? `V${raw.replace(/^v/i, "")}` : null;
})();

export function FeVersion({ className }: Props) {
  if (!feVersionLabel) return null;

  return (
    <span className={`fe-version${className ? ` ${className}` : ""}`}>{feVersionLabel}</span>
  );
}
